import bigDecimal from "js-big-decimal";
import dayjs from "./dayjs";

export function retainIntegerPart(value: number | string): string {
  const bigValue = new bigDecimal(value.toString());
  return bigValue.round(0, bigDecimal.RoundingModes.DOWN).getValue();
}

export function formatTimestampToDayOfWeek(timestamp: number): string {
  const date = new Date(timestamp);
  const daysOfWeek = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  return daysOfWeek[date.getUTCDay()];
}

/**
 * 将 ISO 8601 格式的时间字符串转换为 "MMM DD YYYY, HH:mm" 格式
 * @param isoString ISO 8601 格式的时间字符串，如 "2025-08-29T07:46:46.539Z"
 * @returns 格式化后的时间字符串，如 "Aug 29 2025, 07:46"
 */
export function formatISOToReadable(isoString: string): string {
  return dayjs(isoString).format("MMM DD YYYY, HH:mm");
}

/**
 * 将 YYYY-MM-DD 格式日期转换为 MM/DD/YYYY
 * @param val 日期字符串，如 "2025-08-11"
 * @returns 格式化后的日期字符串，如 "08/11/2025"
 */
export function formatYMDToMDY(val: string): string {
  if (!val) {
    return "-";
  }
  const [y, m, d] = val.split("-");
  return `${m}/${d}/${y}`;
}
